import { useState, useEffect } from 'react';

type Props = {
  key: string;
  // only primitive data types because initialValue should not be stored => value !== initialValue
  initialValue: string | number | boolean;
};

export const useLocalStorage = ({ key, initialValue }: Props) => {
  const [value, setValue] = useState(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      const storedValue = localStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : initialValue;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error parsing local storage item ${key}: ${error}`);
      return initialValue;
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (value !== initialValue) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error setting local storage item ${key}: ${error}`);
      }
    }
  }, [initialValue, key, value]);

  return [value, setValue];
};
